var installedModules = {};
var moduleToHandlerMapping = {
	1922: {
		getter: () => (Promise.all([__webpack_require__.e(9968), __webpack_require__.e(5904), __webpack_require__.e(8008), __webpack_require__.e(2076), __webpack_require__.e(9148)]).then(() => (() => (__webpack_require__(9148))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	9968: {
		getter: () => (Promise.all([__webpack_require__.e(5361), __webpack_require__.e(3393)]).then(() => (() => (__webpack_require__(3393))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.5.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	5904: {
		getter: () => (Promise.all([__webpack_require__.e(5361), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(3620))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.5.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	7900: {
		getter: () => (Promise.all([__webpack_require__.e(9968), __webpack_require__.e(3935)]).then(() => (() => (__webpack_require__(3935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	2465: {
		getter: () => (Promise.all([__webpack_require__.e(404), __webpack_require__.e(9736), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	3842: {
		getter: () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(4456))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	404: {
		getter: () => (Promise.all([__webpack_require__.e(9968), __webpack_require__.e(5904), __webpack_require__.e(1298)]).then(() => (() => (__webpack_require__(1298))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	1416: {
		getter: () => (Promise.all([__webpack_require__.e(2465), __webpack_require__.e(2224)]).then(() => (() => (__webpack_require__(2224))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	2145: {
		getter: () => (Promise.all([__webpack_require__.e(5904), __webpack_require__.e(404), __webpack_require__.e(1416), __webpack_require__.e(847)]).then(() => (() => (__webpack_require__(847))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/core",
	},
	189: {
		getter: () => (__webpack_require__.e(1134).then(() => (() => (__webpack_require__(1134))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/pro-regular-svg-icons",
	},
	5362: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(7250), __webpack_require__.e(37), __webpack_require__.e(3482), __webpack_require__.e(3718), __webpack_require__.e(7013)]).then(() => (() => (__webpack_require__(7013))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/ui",
	},
	5689: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(6127))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^10.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngneat/until-destroy",
	},
	6165: {
		getter: () => (__webpack_require__.e(559).then(() => (() => (__webpack_require__(559))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/pro-solid-svg-icons",
	},
	6987: {
		getter: () => (__webpack_require__.e(4106).then(() => (() => (__webpack_require__(4106))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/datetime",
	},
	7715: {
		getter: () => (__webpack_require__.e(7491).then(() => (() => (__webpack_require__(7491))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-idle/core",
	},
	7726: {
		getter: () => (Promise.all([__webpack_require__.e(9736), __webpack_require__.e(1978), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(3835))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser/animations",
	},
	3718: {
		getter: () => (__webpack_require__.e(8836).then(() => (() => (__webpack_require__(8836))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/angular-fontawesome",
	},
	599: {
		getter: () => (__webpack_require__.e(4254).then(() => (() => (__webpack_require__(4254))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/signalr",
	},
	3273: {
		getter: () => (Promise.all([__webpack_require__.e(5904), __webpack_require__.e(2465), __webpack_require__.e(3842), __webpack_require__.e(1416), __webpack_require__.e(344), __webpack_require__.e(2882)]).then(() => (() => (__webpack_require__(2882))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@acadv/shared/services",
	},
	1881: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(7250), __webpack_require__.e(2511), __webpack_require__.e(4239), __webpack_require__.e(2890)]).then(() => (() => (__webpack_require__(2890))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/autocomplete",
	},
	2525: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(37), __webpack_require__.e(2511), __webpack_require__.e(9177)]).then(() => (() => (__webpack_require__(1991))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/slide-toggle",
	},
	3123: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(4239), __webpack_require__.e(2076), __webpack_require__.e(5327)]).then(() => (() => (__webpack_require__(6256))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/badge",
	},
	3535: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(5675))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/cookies",
	},
	3709: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(7250), __webpack_require__.e(37), __webpack_require__.e(3482), __webpack_require__.e(9792)]).then(() => (() => (__webpack_require__(9792))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/dialog",
	},
	4004: {
		getter: () => (__webpack_require__.e(3213).then(() => (() => (__webpack_require__(3213))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fullstory/browser",
	},
	4049: {
		getter: () => (__webpack_require__.e(320).then(() => (() => (__webpack_require__(320))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@acadv/shell/core",
	},
	9691: {
		getter: () => (__webpack_require__.e(2223).then(() => (() => (__webpack_require__(2223))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-select/ng-select",
	},
	9793: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(7250), __webpack_require__.e(37), __webpack_require__.e(2511), __webpack_require__.e(3480)]).then(() => (() => (__webpack_require__(3480))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/menu",
	},
	3490: {
		getter: () => (() => (__webpack_require__(2867))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	8068: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8070))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	1978: {
		getter: () => (__webpack_require__.e(962).then(() => (() => (__webpack_require__(962))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations/browser",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"344": [
		189,
		5362,
		5689,
		6165,
		6987,
		7715,
		7726
	],
	"404": [
		404
	],
	"1416": [
		1416
	],
	"1615": [
		599,
		3273
	],
	"1922": [
		1922
	],
	"1978": [
		1978
	],
	"2145": [
		2145
	],
	"2465": [
		2465
	],
	"3718": [
		3718
	],
	"3842": [
		3842
	],
	"5904": [
		5904
	],
	"7021": [
		1881,
		2525,
		3123,
		3535,
		3709,
		4004,
		4049,
		9691,
		9793
	],
	"7900": [
		7900
	],
	"9148": [
		3490,
		8068
	],
	"9968": [
		9968
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}